<template>
    <div>
        <div :class="statusClass">

        </div>
        <div v-if="row.status === 'CRITICAL'" class="red--text mt-2 ml-1">
            <i :class="criticalIcon"></i>
        </div>
    </div>
</template>

<script>

export default {
    name: "CIncOverviewStatusCell",

    props: {
        row: {

        }
    },

    computed: {
        statusClass () {
            switch(this.row.status) {
                case "CRITICAL":
                    return "table-status-r";
                case "TERMINATED":
                    return "table-status-g"
                case "INPROCESS":
                    return "table-status-y";
                default:
                    return "table-status-w"
            }
        },

        criticalIcon () {
            if (this.row.siteDown) {
                return "fas fa-bolt"
            }

            return "far fa-clock";
        }
    },

    methods: {
    }
}
</script>

<style scoped>

</style>